import Image from "next/image";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { ModifyRouteUrl } from "@/base/components/parts/header";

export default function Footer() {
    const { t } = useTranslation();
    const router = useRouter();

    return (
        <div className={` bottom-0 w-full py-10`}>
            <div className={`flex flex-col justify-center items-center`}>
                <div className={`flex flex-col sm:flex-row gap-4 w-full items-center justify-between  border-solid border-t-1 border-x-0 border-b-0 border-gray-text/20 sm:p-10 p-2`}>
                    <Image src={`/image/StableProxyFooter.svg`} alt={`Logo`} width={141} height={24} />
                    <Image src={`/image/footer-logos.svg`} alt={`Logos`} width={279} height={35} />
                </div>
                <div className={`flex flex-col md:flex-row gap-4 w-full items-center justify-between  border-solid border-t-1 border-x-0 border-b-0 border-gray-text/20 sm:p-10 p-2`}>
                    <div>
                        <p className={`sm:text-sm text-[10px] text-gray-text-darkgray`}>StableProxy.pl © 2023-2024</p>
                    </div>
                    <div className={`flex gap-3`}>
                        <a
                            href="/p/docs/publicoffer"
                            className={`sm:text-sm text-[10px] text-gray-text-darkgray hover:text-gray-text`}
                            onClick={(e) => {
                                e.preventDefault();
                                router.push(ModifyRouteUrl(router, "/p/docs/publicoffer"), undefined, {
                                    shallow: false,
                                });
                            }}
                        >{`${t("common:footerpl.public-offer")}`}</a>
                        <a
                            href="/p/docs/privacypolicy"
                            className={`sm:text-sm text-[10px] text-gray-text-darkgray hover:text-gray-text`}
                            onClick={(e) => {
                                e.preventDefault();
                                router.push(ModifyRouteUrl(router, "/p/docs/privacypolicy"), undefined, {
                                    shallow: false,
                                });
                            }}
                        >{`${t("common:footerpl.privacy-policy")}`}</a>
                        <a
                            href="/p/docs/termsofservice"
                            className={`sm:text-sm text-[10px] text-gray-text-darkgray hover:text-gray-text`}
                            onClick={(e) => {
                                e.preventDefault();
                                router.push(ModifyRouteUrl(router, "/p/docs/termsofservice"), undefined, {
                                    shallow: false,
                                });
                            }}
                        >{`${t("common:footerpl.service-conditions")}`}</a>
                    </div>
                </div>
            </div>
        </div>
    );
}
